import request from '@/utils/request'

//提交已读状态
export function alreadyRead(data) {
  return request({
    url: '/messages/read',
    method: 'put',
    data
  })
}
//获取消息列表
export function getUserMessage(page,limit,status,level) {
  return request({
    url:level?('/messages?page='+page+'&limit='+limit+'&status='+status+'&level='+level):('/messages?page='+page+'&limit='+limit+'&status='+status),
    method: 'get'
  })
}
//提交申请
export function sendApply(data) {
  return request({
    url: '/messages/send',
    method: 'post',
    data
  })
}



//提交申请
export function getMessageCount() {
  return request({
    url: '/messages/status',
    method: 'get'
  })
}
